import { defineComponent } from 'vue';
import { QLinearProgress } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

export default defineComponent({
    name: 'cc-progress-bar-dsgn',
    mixins: [BaseComponentMixin],
    components: { QLinearProgress },
    computed: {
        containerStyle() {
            return {
                ...utils.getStyleHints(this.controlData?.StyleHints),
                ...utils.getSize(this.controlData?.SizeOptions, this.parentType, this.$parent),
                overflow: 'hidden',
            };
        },
        color() {
            if (this.controlData?.Color && !this.controlData.Color.includes('{'))
                return this.controlData.Color;
            return 'orange';
        },
        /** 0–1 for QLinearProgress, matching runtime (percent / 100) */
        progressValue() {
            let pct = 35;
            if (this.controlData?.ValueExpression)
                pct = utils.helpers.tryParseInt(this.controlData.ValueExpression, 35);
            return Math.min(1, Math.max(0, pct / 100));
        },
        bufferValue() {
            let pct = 100;
            if (this.controlData?.BufferValueExpression)
                pct = utils.helpers.tryParseInt(this.controlData.BufferValueExpression, 100);
            return Math.min(1, Math.max(0, pct / 100));
        },
        height() {
            if (
                this.controlData?.SizeOptions?.Height &&
                this.controlData.SizeOptions.Height.Mode == 'Fixed'
            )
                return this.controlData.SizeOptions.Height.Value || 4;
            return 4;
        },
    },
    props: {
    },
    render() {
        try {
            const contentSlot = this.controlData.Content
                ? { default: () => <span>{this.controlData.Content}</span> }
                : undefined;

            return (
                <div
                    style={this.containerStyle}
                    class={{
                        'c-ProgressBar': true,
                        'c-ProgressBarDsgn': true,
                        [`c-name-${this.name || 'unnamed'}`]: true,
                        'designer-container': true,
                        selected: this.selected$,
                    }}
                    onClick={(e) => this.handleClick(e)}>
                    <div class={{ 'designer-container-hovering': true, 'designer-container-selected-clickthrough': this.selected$ }} />
                    <QLinearProgress
                        style={{ width: '100%', height: '100%' }}
                        value={this.progressValue}
                        buffer={this.bufferValue}
                        size={`${this.height}px`}
                        color={this.color}
                        indeterminate={this.controlData.Indeterminate}
                        reverse={this.controlData.Reverse}
                        rounded={this.controlData.Rounded}
                        stripe={this.controlData.Striped}
                        {...(contentSlot ? { vSlots: contentSlot } : {})}
                    />
                </div>
            );
        }
        catch (e) {
            utils.error('ProgressBarDsgn Render failed', e);
            return <div>ProgressBar Failed to Render {String(e)}</div>;
        }
    },
});
